import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@environment';
import { OpsProfileResponse } from '@shared/models/api/ops-event-api/ops-profile-response.interface';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UserService {
  private readonly baseUrl = `${environment.api.opsEvent}/api/users`;

  readonly #http = inject(HttpClient);

  getTasUsers(): Observable<OpsProfileResponse[]> {
    return this.#http.get<OpsProfileResponse[]>(`${this.baseUrl}/tas`);
  }

  getAllUsers(): Observable<OpsProfileResponse[]> {
    return this.#http.get<OpsProfileResponse[]>(`${this.baseUrl}/all`);
  }

  getUser(id: string): Observable<OpsProfileResponse> {
    return this.#http.get<OpsProfileResponse>(`${this.baseUrl}/${id}`);
  }
}
